(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Plans.MarketingPlan",
                    {
                        url: "/MarketingPlan/{marketingPlanId}",
                        component: "marketingplanNew",
                        PageTitle: "Marketing Plan | Marketing Tracker",
                        resolve: {
                            marketingPlanDocument: ["$stateParams", "marketingPlanApi", "marketingTrackerAgent",
                                function ($stateParams, marketingPlanApi, marketingTrackerAgent) {
                                    return marketingPlanApi
                                        .getMarketingPlanDocument(marketingTrackerAgent.AgentId,
                                            $stateParams.marketingPlanId).then(function (file) {
                                                return URL.createObjectURL(file);
                                            });
                                }]
                        }
                    });
        }
    ]);

    app.component("marketingplanNew",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Plans/MarketingPlan/marketingplan-new-template.html",
            controller: marketingPlanNewController,
            bindings: {
                marketingPlanDocument: "<"
            }
        });

    marketingPlanNewController.$inject = ["$scope"];
    function marketingPlanNewController($scope) {
        var $ctrl = this;

        $scope.$on("$destroy",
            function () {
                if ($ctrl.marketingPlanDocument)
                    URL.revokeObjectURL($ctrl.marketingPlanDocument);
            });
    }

})(window.app);